var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.365,
    height: 26.04,
    viewBox: "0 0 37.365 26.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_31880",
    x: 0,
    y: 0,
    width: 37.365,
    height: 26.04,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SE-Flag",
    transform: "translate(1.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1.5, -0.5)",
    filter: "url(#Rectangle_31880)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31880-2",
    "data-name": "Rectangle 31880",
    width: 34.365,
    height: 23.04,
    transform: "translate(1.5 0.5)",
    fill: "#0565a7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_40589",
    "data-name": "Path 40589",
    d: "M10.473,0V9.217H0v4.607H10.473V23.04H14.94V13.824H34.363V9.217H14.94V0Z",
    transform: "translate(0)",
    fill: "#f5c200"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeFlag);
export default __webpack_public_path__ + "static/media/SE-Flag.b651269f32d5e1d823be6966d76484f7.svg";
export { ForwardRef as ReactComponent };